import http from "@/utils/request";

const declare = {
  list: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.queryForOmsUsers",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  addOrModify: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.addOrModifyOmsUser",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  bindMerchant: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.bindMerchant",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  bindCustomerId: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.bindCustomerId",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  setWarehouseReceiptUser: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.setWarehouseReceiptUser",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),

  changeUserStatus: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.changeUserStatus",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  editUserPasswordDirect: (data) =>
    http.sendRequest({
      METHOD_NAME: "user.editUserPasswordDirect",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
};

export default declare;
